module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-screenShare_green.c268d6c5.svg";